import BaseService from "./BaseService";

export default class AcordoService extends BaseService {

  constructor(self) {
    super(self);
  }

  ListarAcordo(parameters) {
    return this.ExecutaFetch("/api/Acordo/ListarAcordo", "POST", parameters);
  }

}